import {
	ChangeDetectionStrategy,
	Component,
	inject,
	InjectionToken,
} from '@angular/core';
import { TuiDialogContext } from '@taiga-ui/core';
import {
	POLYMORPHEUS_CONTEXT,
	PolymorpheusContent,
	PolymorpheusOutlet,
} from '@taiga-ui/polymorpheus';
import { DialogHeaderComponent } from '../dialog-header/dialog-header.component';

export const DIALOG_FRAME_CONTENT = new InjectionToken<PolymorpheusContent>(
	'DIALOG_FRAME_CONTENT',
);

@Component({
	selector: 'mar-dialog-frame',
	standalone: true,
	imports: [DialogHeaderComponent, PolymorpheusOutlet],
	template: `
		<mar-dialog-header />
		<div class="pt-6 relative">
			<ng-container *polymorpheusOutlet="content; context: context" />
		</div>
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: { class: 'block w-full' },
})
export class DialogFrameComponent {
	protected readonly context = inject(
		POLYMORPHEUS_CONTEXT,
	) as TuiDialogContext<
		unknown,
		{ headerText: string; subheaderText?: string }
	>;

	protected readonly content = inject(DIALOG_FRAME_CONTENT);
}
